import { getAuth } from 'firebase/auth';

interface SentryUser {
  id: string;
  email?: string;
  username?: string;
}

const getUserForSentryFromClientSide = (): SentryUser | undefined => {
  const auth = getAuth();
  const firebaseUser = auth.currentUser;

  if (!firebaseUser) {
    return undefined;
  }

  return {
    id: firebaseUser.uid,
    email: firebaseUser.email || undefined,
    username: firebaseUser.email || undefined,
  };
};

export default getUserForSentryFromClientSide;
